import { somarCents } from '../dinheiro.js';
import { FormaPagamento, TipoEntrega } from '../dominio.js';
import { calcularTaxaEntrega } from './entrega.js';
export function calcularPedido(e) {
    if (e.itens.length === 0) {
        return { ok: false, codigo: 'CARRINHO_VAZIO', mensagem: 'O carrinho está vazio.' };
    }
    for (const item of e.itens) {
        if (!Number.isInteger(item.quantidade) || item.quantidade < 1) {
            return {
                ok: false,
                codigo: 'QUANTIDADE_INVALIDA',
                mensagem: `Quantidade inválida em "${item.nome}".`,
            };
        }
        if (!Number.isInteger(item.precoUnitCents) || item.precoUnitCents < 0) {
            return { ok: false, codigo: 'PRECO_INVALIDO', mensagem: `Preço inválido em "${item.nome}".` };
        }
        for (const ad of item.adicionais) {
            if (!Number.isInteger(ad.quantidade) || ad.quantidade < 1) {
                return {
                    ok: false,
                    codigo: 'QUANTIDADE_INVALIDA',
                    mensagem: `Quantidade inválida no adicional "${ad.nome}".`,
                };
            }
            if (!Number.isInteger(ad.precoUnitCents) || ad.precoUnitCents < 0) {
                return {
                    ok: false,
                    codigo: 'PRECO_INVALIDO',
                    mensagem: `Preço inválido no adicional "${ad.nome}".`,
                };
            }
        }
    }
    const itens = e.itens.map((item) => {
        const adicionaisCents = somarCents(item.adicionais.map((a) => a.precoUnitCents * a.quantidade));
        return {
            ...item,
            adicionaisCents,
            totalCents: (item.precoUnitCents + adicionaisCents) * item.quantidade,
        };
    });
    const subtotalCents = somarCents(itens.map((i) => i.totalCents));
    const taxa = calcularTaxaEntrega(e.tipo, e.entrega, e.destino);
    if (!taxa.ok)
        return { ok: false, codigo: taxa.codigo, mensagem: taxa.mensagem };
    const descontoCents = e.descontoCents ?? 0;
    if (!Number.isInteger(descontoCents) || descontoCents < 0) {
        return { ok: false, codigo: 'DESCONTO_INVALIDO', mensagem: 'Desconto inválido.' };
    }
    if (descontoCents > subtotalCents) {
        return {
            ok: false,
            codigo: 'DESCONTO_INVALIDO',
            mensagem: 'O desconto não pode ser maior que o subtotal.',
        };
    }
    const minimo = e.pedidoMinimoCents ?? 0;
    if (e.tipo === TipoEntrega.ENTREGA && subtotalCents < minimo) {
        return {
            ok: false,
            codigo: 'PEDIDO_MINIMO',
            mensagem: 'O subtotal está abaixo do pedido mínimo para entrega.',
        };
    }
    const totalCents = subtotalCents + taxa.taxaCents - descontoCents;
    if (e.formaPagamento === FormaPagamento.DINHEIRO &&
        e.trocoParaCents != null &&
        e.trocoParaCents < totalCents) {
        return {
            ok: false,
            codigo: 'TROCO_INSUFICIENTE',
            mensagem: 'O valor informado para troco é menor que o total do pedido.',
        };
    }
    return {
        ok: true,
        itens,
        subtotalCents,
        taxaEntregaCents: taxa.taxaCents,
        descontoCents,
        totalCents,
        tempoEstimadoMin: taxa.tempoEstimadoMin,
        origemTaxa: taxa.origem,
    };
}
/** Valida min/max por grupo de adicionais. Erro aqui é 422, não 500. */
export function validarGrupos(grupos, escolhas) {
    for (const g of grupos) {
        const total = escolhas
            .filter((x) => x.grupoId === g.id)
            .reduce((acc, x) => acc + x.quantidade, 0);
        if (total < g.min) {
            return { ok: false, mensagem: `Escolha ao menos ${g.min} item em "${g.nome}".` };
        }
        if (total > g.max) {
            return { ok: false, mensagem: `Escolha no máximo ${g.max} itens em "${g.nome}".` };
        }
    }
    const idsValidos = new Set(grupos.map((g) => g.id));
    const invalido = escolhas.find((x) => !idsValidos.has(x.grupoId));
    if (invalido) {
        return { ok: false, mensagem: 'Adicional que não pertence a este produto.' };
    }
    return { ok: true };
}
/** Troco a devolver, para a comanda do caixa. */
export function trocoCents(totalCents, trocoParaCents) {
    return Math.max(0, trocoParaCents - totalCents);
}
//# sourceMappingURL=precificacao.js.map